import React from 'react';

interface ActivityItem {
    id: number;
    type: string;
    title: string;
    description: string;
    location: string;
    time: string;
    status: string;
}

interface RecentActivityData {
    today: ActivityItem[];
    thisWeek: ActivityItem[];
}

interface RecentActivityProps {
    data: RecentActivityData;
}

const RecentActivity: React.FC<RecentActivityProps> = ({ data }) => {
    const getActivityIcon = (type: string) => {
        const iconMap = {
            staff_login: 'ri-user-line',
            configuration: 'ri-settings-line',
            manager_login: 'ri-admin-line',
            staff_permissions: 'ri-shield-user-line',
            payment_method: 'ri-bank-card-line',
            performance_optimization: 'ri-speed-up-line',
            menu_update: 'ri-restaurant-line',
        };
        return iconMap[type as keyof typeof iconMap] || 'ri-information-line';
    };

    const getStatusColor = (status: string) => {
        const colorMap = {
            success: 'text-success',
            info: 'text-info',
            warning: 'text-warning',
            danger: 'text-danger',
        };
        return colorMap[status as keyof typeof colorMap] || 'text-muted';
    };

    const renderActivityItem = (activity: ActivityItem) => (
        <div key={activity.id} className="activity-item">
            <div className="activity-icon">
                <i className={`${getActivityIcon(activity.type)} ${getStatusColor(activity.status)}`}></i>
            </div>
            <div className="activity-content">
                <div className="activity-header d-flex align-items-center justify-content-between">
                    <h6 className="activity-title mb-1">{activity.title}</h6>
                    <span className="activity-time text-muted">{activity.time}</span>
                </div>
                <p className="activity-description text-muted mb-1">{activity.description}</p>
                <div className="activity-location">
                    <i className="ri-map-pin-line me-1 text-muted"></i>
                    <span className="text-muted">{activity.location}</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="recent-activity-card dashboard-card dashboard-card-wrapper coming-soon-card">
            <div className="card-header mb-3">
                <h5 className="card-title mb-0">
                    <i className="ri-history-line me-2"></i>
                    Recent Activity
                </h5>
            </div>

            <div className="activity-content">
                <div className="activity-section mb-4">
                    <h6 className="activity-section-title mb-3">Today</h6>
                    <div className="activity-list">{data.today.map(renderActivityItem)}</div>
                </div>

                <div className="activity-section">
                    <h6 className="activity-section-title mb-3">This Week</h6>
                    <div className="activity-list">{data.thisWeek.map(renderActivityItem)}</div>
                </div>
            </div>
        </div>
    );
};

export default RecentActivity;
